module.exports = __webpack_public_path__ + "img/label.2accd7d0.jpg";